import { InjectionToken, Signal, signal } from '@angular/core';

/** Touch input (phone or tablet, any width): hit targets grow to 44px, R12. */
export const IS_COARSE_POINTER = new InjectionToken<Signal<boolean>>('IS_COARSE_POINTER', {
  providedIn: 'root',
  factory: () => {
    const mql = window.matchMedia('(pointer: coarse)');
    const coarse = signal(mql.matches);
    mql.addEventListener('change', (e: MediaQueryListEvent) => coarse.set(e.matches));
    return coarse.asReadonly();
  },
});
